import React, { useState, useEffect } from "react";
import {
    Collapse,
    Navbar,
    NavbarToggler,
    NavbarBrand,
    NavbarText,
    Nav,
    Button,
    Media,
} from "reactstrap";

import { Link } from "react-router-dom";

const SideBar = (props) => {
    const [isOpen, setisOpen] = useState(false);
    const toggle = () => {
        setisOpen(!isOpen);
    };
    const [ClassesData, setClassesData] = useState([]);
    const Role = "Teacher"
    useEffect(() => {
        setClassesData([
            {
                id: "one",
                program: "English Tution - Grade 5",
                data:
                    "Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et.",
                avatarData: [
                    {
                        studentName: "Maheen Mushtaq",
                        imagePath:
                            "https://demos.creative-tim.com/argon-dashboard-pro/assets/img/theme/team-4.jpg",
                        online: true,
                        value1: Math.floor(Math.random() * 100),
                        value2: Math.floor(Math.random() * 100),
                        value3: Math.floor(Math.random() * 100),
                    },
                    {
                        studentName: "Shahreyar Ghazanfar",
                        imagePath:
                            "https://i.picsum.photos/id/1011/5472/3648.jpg?hmac=Koo9845x2akkVzVFX3xxAc9BCkeGYA9VRVfLE4f0Zzk",
                        online: false,
                        value1: Math.floor(Math.random() * 100),
                        value2: Math.floor(Math.random() * 100),
                        value3: Math.floor(Math.random() * 100),
                    },
                    {
                        studentName: "Sami Ali Khan",
                        imagePath:
                            "https://demos.creative-tim.com/argon-dashboard-pro/assets/img/theme/team-4.jpg",
                        online: true,
                        value1: Math.floor(Math.random() * 100),
                        value2: Math.floor(Math.random() * 100),
                        value3: Math.floor(Math.random() * 100),
                    },
                    {
                        studentName: "Saqib",
                        imagePath:
                            "https://demos.creative-tim.com/argon-dashboard-pro/assets/img/theme/team-4.jpg",
                        online: false,
                        value1: Math.floor(Math.random() * 100),
                        value2: Math.floor(Math.random() * 100),
                        value3: Math.floor(Math.random() * 100),
                    },
                    {
                        studentName: "Riffat",
                        imagePath:
                            "https://demos.creative-tim.com/argon-dashboard-pro/assets/img/theme/team-4.jpg",
                        online: true,
                        value1: Math.floor(Math.random() * 100),
                        value2: Math.floor(Math.random() * 100),
                        value3: Math.floor(Math.random() * 100),
                    },
                    {
                        studentName: "Malik",
                        imagePath:
                            "https://i.picsum.photos/id/237/200/300.jpg?hmac=TmmQSbShHz9CdQm0NkEjx1Dyh_Y984R9LpNrpvH2D_U",
                        online: true,
                        value1: Math.floor(Math.random() * 100),
                        value2: Math.floor(Math.random() * 100),
                        value3: Math.floor(Math.random() * 100),
                    },
                ],
            },
            {
                id: "two",
                program: "Math Tution - Grade 5",
                data:
                    "Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et.",
                avatarData: [
                    {
                        studentName: "Hamza",
                        imagePath:
                            "https://demos.creative-tim.com/argon-dashboard-pro/assets/img/theme/team-4.jpg",
                        online: true,
                    },
                    {
                        studentName: "Faheem",
                        imagePath:
                            "https://demos.creative-tim.com/argon-dashboard-pro/assets/img/theme/team-4.jpg",
                        online: true,
                    },
                    {
                        studentName: "Afzal",
                        imagePath:
                            "https://demos.creative-tim.com/argon-dashboard-pro/assets/img/theme/team-4.jpg",
                        online: true,
                    },
                ],
            },
            {
                id: "three",
                program: "Math Tution - Grade 7",
                data:
                    "Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et.",
                avatarData: [
                    {
                        studentName: "Hamza",
                        imagePath:
                            "https://demos.creative-tim.com/argon-dashboard-pro/assets/img/theme/team-4.jpg",
                        online: true,
                    },
                    {
                        studentName: "Faheem",
                        imagePath:
                            "https://demos.creative-tim.com/argon-dashboard-pro/assets/img/theme/team-4.jpg",
                        online: true,
                    },
                    {
                        studentName: "Afzal",
                        imagePath:
                            "https://demos.creative-tim.com/argon-dashboard-pro/assets/img/theme/team-4.jpg",
                        online: true,
                    },
                ],
            },
            {
                id: "four",
                program: "English Tution - Grade 7",
                data:
                    "Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et.",
                avatarData: [
                    {
                        studentName: "Hamza",
                        imagePath:
                            "https://demos.creative-tim.com/argon-dashboard-pro/assets/img/theme/team-4.jpg",
                        online: true,
                        value1: 10,
                        value2: 25,
                        value3: 55,
                    },
                    {
                        studentName: "Faheem",
                        imagePath:
                            "https://demos.creative-tim.com/argon-dashboard-pro/assets/img/theme/team-4.jpg",
                        online: true,
                        value1: 10,
                        value2: 25,
                        value3: 55,
                    },
                    {
                        studentName: "Afzal",
                        imagePath:
                            "https://demos.creative-tim.com/argon-dashboard-pro/assets/img/theme/team-4.jpg",
                        online: true,
                        value1: 10,
                        value2: 25,
                        value3: 55,
                    },
                ],
            },
        ]);
        // fetch('/posts')
        //   .then((res) => {
        //     debugger;
        //     console.log("Response", res.json())
        //   })
        //   .catch((err) => {
        //     debugger;
        //     console.log(err);
        //     return err;
        //   })

    }, []);
    const changeValueonHover = () => {
        console.log("...");
        setClassesData([
            {
                id: "one",
                program: "English Tution - Grade 5",
                data:
                    "Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et.",
                avatarData: [
                    {
                        studentName: "Maheen Mushtaq",
                        imagePath:
                            "https://demos.creative-tim.com/argon-dashboard-pro/assets/img/theme/team-4.jpg",
                        online: true,
                        value1: Math.floor(Math.random() * 100),
                        value2: Math.floor(Math.random() * 100),
                        value3: Math.floor(Math.random() * 100),
                    },
                    {
                        studentName: "Shahreyar Ghazanfar",
                        imagePath:
                            "https://i.picsum.photos/id/1011/5472/3648.jpg?hmac=Koo9845x2akkVzVFX3xxAc9BCkeGYA9VRVfLE4f0Zzk",
                        online: false,
                        value1: Math.floor(Math.random() * 100),
                        value2: Math.floor(Math.random() * 100),
                        value3: Math.floor(Math.random() * 100),
                    },
                    {
                        studentName: "Sami Ali Khan",
                        imagePath:
                            "https://demos.creative-tim.com/argon-dashboard-pro/assets/img/theme/team-4.jpg",
                        online: true,
                        value1: Math.floor(Math.random() * 100),
                        value2: Math.floor(Math.random() * 100),
                        value3: Math.floor(Math.random() * 100),
                    },
                    {
                        studentName: "Saqib",
                        imagePath:
                            "https://demos.creative-tim.com/argon-dashboard-pro/assets/img/theme/team-4.jpg",
                        online: false,
                        value1: Math.floor(Math.random() * 100),
                        value2: Math.floor(Math.random() * 100),
                        value3: Math.floor(Math.random() * 100),
                    },
                    {
                        studentName: "Riffat",
                        imagePath:
                            "https://demos.creative-tim.com/argon-dashboard-pro/assets/img/theme/team-4.jpg",
                        online: true,
                        value1: Math.floor(Math.random() * 100),
                        value2: Math.floor(Math.random() * 100),
                        value3: Math.floor(Math.random() * 100),
                    },
                    {
                        studentName: "Malik",
                        imagePath:
                            "https://i.picsum.photos/id/237/200/300.jpg?hmac=TmmQSbShHz9CdQm0NkEjx1Dyh_Y984R9LpNrpvH2D_U",
                        online: true,
                        value1: Math.floor(Math.random() * 100),
                        value2: Math.floor(Math.random() * 100),
                        value3: Math.floor(Math.random() * 100),
                    },
                ],
            },
            {
                id: "two",
                program: "Math Tution - Grade 5",
                data:
                    "Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et.",
                avatarData: [
                    {
                        studentName: "Hamza",
                        imagePath:
                            "https://demos.creative-tim.com/argon-dashboard-pro/assets/img/theme/team-4.jpg",
                        online: true,
                    },
                    {
                        studentName: "Faheem",
                        imagePath:
                            "https://demos.creative-tim.com/argon-dashboard-pro/assets/img/theme/team-4.jpg",
                        online: true,
                    },
                    {
                        studentName: "Afzal",
                        imagePath:
                            "https://demos.creative-tim.com/argon-dashboard-pro/assets/img/theme/team-4.jpg",
                        online: true,
                    },
                ],
            },
            {
                id: "three",
                program: "Math Tution - Grade 7",
                data:
                    "Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et.",
                avatarData: [
                    {
                        studentName: "Hamza",
                        imagePath:
                            "https://demos.creative-tim.com/argon-dashboard-pro/assets/img/theme/team-4.jpg",
                        online: true,
                    },
                    {
                        studentName: "Faheem",
                        imagePath:
                            "https://demos.creative-tim.com/argon-dashboard-pro/assets/img/theme/team-4.jpg",
                        online: true,
                    },
                    {
                        studentName: "Afzal",
                        imagePath:
                            "https://demos.creative-tim.com/argon-dashboard-pro/assets/img/theme/team-4.jpg",
                        online: true,
                    },
                ],
            },
            {
                id: "four",
                program: "English Tution - Grade 7",
                data:
                    "Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et.",
                avatarData: [
                    {
                        studentName: "Hamza",
                        imagePath:
                            "https://demos.creative-tim.com/argon-dashboard-pro/assets/img/theme/team-4.jpg",
                        online: true,
                        value1: 10,
                        value2: 25,
                        value3: 55,
                    },
                    {
                        studentName: "Faheem",
                        imagePath:
                            "https://demos.creative-tim.com/argon-dashboard-pro/assets/img/theme/team-4.jpg",
                        online: true,
                        value1: 10,
                        value2: 25,
                        value3: 55,
                    },
                    {
                        studentName: "Afzal",
                        imagePath:
                            "https://demos.creative-tim.com/argon-dashboard-pro/assets/img/theme/team-4.jpg",
                        online: true,
                        value1: 10,
                        value2: 25,
                        value3: 55,
                    },
                ],
            },
        ]);
    };
    return (
        <React.Fragment>
            <Navbar color="dark" dark expand="md">
                <NavbarBrand>
                    {/* <Media src={require("../../Images/fullLogo.png")} height="40" /> */}
                </NavbarBrand>
                <NavbarToggler onClick={toggle} />
                <Collapse isOpen={isOpen} navbar>
                    <Nav className="ml-auto" navbar>
                        <NavbarText className="text-light font-weight-bold mt-2 m-2">
                            Miss Rabia
            </NavbarText>
                        <NavbarText className="text-light font-weight-bold">
                            <img
                                src="https://demos.creative-tim.com/argon-dashboard-pro/assets/img/theme/team-4.jpg"
                                alt="Avatar"
                                class="avatar"
                            />
                        </NavbarText>
                        <NavbarText className="text-light font-weight-bold mt-2 ml-2">
                            <Link to="/">
                                <Button
                                    size="sm"
                                    style={{ backgroundColor: "#FED700", color: "black" }}
                                >
                                    Logout
                </Button>
                            </Link>
                        </NavbarText>
                    </Nav>
                </Collapse>

                {/* <NavItem>
          <NavLink href="/components/">Components</NavLink>
        </NavItem> */}
                {/* {

      window.location.host === "feeds.lincolnmethod.com" && !this.state.isTeacherLoggedIn ?

        <Switch
          checked={ !this.state.isTuitionsPostType }
          onChange={() => this.onToggleSwitch()}
          uncheckedIcon={
            <div className="switchLabel">
              Tuitions
            </div>
          }
          checkedIcon={
            <div className="switchLabel">
              Self learning
            </div>
          }
          className={this.state.isTuitionsPostType ? "highest react-switch medium" : "lowest react-switch medium"}
          id="icon-switch"
        />

      : null

    }
    {
      !this.state.showLoginModal ?
        <Button style={{position: 'absolute', right: '15px'}} onClick={this.logout} className="userName" size="sm" color="secondary">Logout</Button>
      : null
    } */}
            </Navbar>

            <div style={{ padding: "2vh 0" }}>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-3">
                            {Role === "Teacher" ? (
                                // <RightSection rightSectionData={ClassesData} />
                                <label>HAHA</label>
                            ) : (
                                    // <RightSectionEM />
                                    <label>HAHA</label>

                                )}
                        </div>



                        {props.children}
                    </div>
                </div>
            </div>




        </React.Fragment>
    );
};

export default SideBar;
